import { Card, CardContent, CardHeader, Typography, CodeBlock, Markdown } from "@altimateai/lego";
import DownloadConfigurationsTemplate from "./dataMates/DownloadConfigurationsTemplate";
import { Teammate } from "../mcp/mcpSlice";

interface ClaudeCodeInstructionsProps {
  teammate?: Teammate;
}

const ClaudeCodeInstructions = ({ teammate }: ClaudeCodeInstructionsProps) => {
  const steps = [
    {
      title: "Install Nodejs",
      content:
        "Install Nodejs if not already installed. You can download it from [here](https://nodejs.org/en/download/).",
    },
    {
      title: "Install MCP CLI",
      content: "Install the AltimateAI MCP CLI globally using npm:",
      command: "npm install -g @altimateai/datamate",
    },
    {
      title: "Setup configurations (optional)",
      content: `- If you have not used datamate \`${teammate?.name}\` so far with vscode/cursor, then follow these steps
- Download the configurations template from the button below
- Fill the values in the template file
- Proceed to next step to complete the configurations setup and start the MCP server`,
      actions: [
        <DownloadConfigurationsTemplate
          key={"download-configurations-template"}
          teammate={teammate}
        />,
      ],
    },
    {
      title: "Start MCP Server",
      content: `- Run the following command in your terminal to start the MCP server
- Argument \`--config-file\` is optional and will be needed only if you are setting this datamate for the first time in your machine`,
      command: `datamate start --datamate ${teammate?.id} --client claude-code  --config-file <path-to-your-template-file>`,
    },
    {
      title: "Verify Connection",
      content: `- In your Claude Code session, run the following command to verify the connection
- \`datamate\` mcp server should be listed with connected status`,
      command: "/mcp",
    },
  ];

  return (
    <div className="al-max-w-3xl al-mx-auto">
      <p>Follow these steps to connect and use Datamate with Claude Code:</p>

      <div className="al-space-y-6">
        {steps.map((step, index) => (
          <Card key={index}>
            <CardHeader className="!al-p-3 !al-pb-0">
              <Typography variant="section-heading">
                {index + 1}. {step.title}
              </Typography>
            </CardHeader>
            <CardContent className="!al-p-3">
              <p className="al-text-gray-700">
                <Markdown content={step.content} />
              </p>
              {step.actions && <div className="al-my-4">{step.actions}</div>}
              {step.command && (
                <div>
                  <CodeBlock
                    code={step.command}
                    language="sql"
                    theme="light"
                    editorTheme="tomorrow"
                  />
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ClaudeCodeInstructions;
